module.exports = __webpack_public_path__ + "img/logoExist.fe2f00aa.svg";